import { render, staticRenderFns } from "./CctvDangerAreaConfig.vue?vue&type=template&id=e132d212&"
import script from "./CctvDangerAreaConfig.vue?vue&type=script&lang=js&"
export * from "./CctvDangerAreaConfig.vue?vue&type=script&lang=js&"
import style0 from "./CctvDangerAreaConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e132d212')) {
      api.createRecord('e132d212', component.options)
    } else {
      api.reload('e132d212', component.options)
    }
    module.hot.accept("./CctvDangerAreaConfig.vue?vue&type=template&id=e132d212&", function () {
      api.rerender('e132d212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/CctvDangerAreaConfig.vue"
export default component.exports